import React from 'react';
import { Lozenge, Typography } from '@packages/ui/primitives';
import type { EachRowHeaderConfig } from '../../../types/layout';
import { resolveRowHeader } from '../../../utils/eachRowHeader';

interface FormEachRowHeaderProps {
  config: EachRowHeaderConfig | undefined;
  index: number;
  rowValues?: Record<string, unknown>;
}

export const FormEachRowHeader = React.memo(function FormEachRowHeader({
  config,
  index,
  rowValues,
}: FormEachRowHeaderProps): React.ReactElement | null {
  const header = resolveRowHeader(config, index, rowValues);

  if (header.style === 'none' || header.label == null) {
    return null;
  }

  if (header.style === 'title-field') {
    return (
      <Typography variant='body-m' semanticId={`eachRowTitle.${index}`}>
        {header.label}
      </Typography>
    );
  }

  return (
    <Lozenge
      variant={(header.badgeVariant ?? 'success') as 'success' | 'info' | 'warning' | 'default'}
      title={header.label}
    />
  );
});
